module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921031151_T.dff0482c.jpg";